"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const is_empty_1 = __importDefault(require("../../utils/is-empty"));
const message_defaults_json_1 = __importDefault(require("../../message-defaults.json"));
const weighting = [1, 3, 7, 9, 1, 3, 7, 9];
const divisor = 10;
const messageDefault = message_defaults_json_1.default.medicare;
const validationBuilder = (message) => {
    const getMessage = (key) => lodash_1.default.get(message, key, messageDefault[key]);
    return (value) => {
        if (!(0, is_empty_1.default)(value) && lodash_1.default.isString(value)) {
            // Strip out all non digits
            const transformed = lodash_1.default.replace(value, /[^0-9]+/g, '');
            // Transformed version must be 10 digits in length
            if (!transformed || transformed.length !== 10) {
                return getMessage('length');
            }
            // First digit should be between 2 and 6
            const firstDigit = +transformed.substring(0, 1);
            if (firstDigit < 2 || firstDigit > 6) {
                return getMessage('firstDigit');
            }
            // Perform checksum validation
            // Separate parts of medicare number
            const identifier = lodash_1.default.split(transformed.substring(0, 8), '');
            const checksum = transformed.substring(8, 9);
            const total = (0, lodash_1.default)(weighting)
                .map((weight, index) => weight * +identifier[index])
                .sum();
            if (+checksum !== total % divisor) {
                return getMessage('checkSum');
            }
        }
        return null;
    };
};
validationBuilder.messageDefault = messageDefault;
exports.default = validationBuilder;
